export default __webpack_public_path__ + "static/media/rd.e1956465.svg";